<template>
  <div class="other_page_r">
    <el-card class="card_box">

      <div class="search_box">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增配置</el-button>
      </div>

      <div class="table_box">
        <tablec :tableData="tableData" @edit="handleEdit" @delete="handleDelete"></tablec>
      </div>

      <div class="flex justify_content_end aligin_items_c table_footer custom_btn">
        <div>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="searchInfo.page"
            :limit.sync="searchInfo.size"
            @pagination="getDataList"
          />
        </div>
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <app-version-dialog
      :visible.sync="dialogVisible"
      :isEdit="isEdit"
      :editData="editData"
      @submit="handleSubmit"
    ></app-version-dialog>
  </div>
</template>

<script>
import tablec from "./table.vue";
import AppVersionDialog from "./dialog.vue";
import pagination from "@/components/Pagination.vue";
import {
  getAppVersionConfigList,
  addAppVersionConfig,
  updateAppVersionConfig,
  deleteAppVersionConfig,
} from "@/api/appVersion";

export default {
  components: { tablec, AppVersionDialog, pagination },
  name: "AppVersionConfig",
  data() {
    return {
      tableData: [],
      total: 0,
      searchInfo: {
        page: 1,
        size: 10,
      },
      dialogVisible: false,
      isEdit: false,
      editData: {},
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      getAppVersionConfigList(this.searchInfo)
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.message || "获取列表失败");
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取列表失败");
        });
    },

    handleAdd() {
      this.isEdit = false;
      this.editData = {};
      this.dialogVisible = true;
    },

    handleEdit(row) {
      this.isEdit = true;
      this.editData = row;
      this.dialogVisible = true;
    },

    handleDelete(row) {
      this.$confirm("确定删除该配置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAppVersionConfig({ id: row.id })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("删除成功");
                this.getDataList();
              } else {
                this.$message.error(res.message || "删除失败");
              }
            })
            .catch((error) => {
              this.$message.error(error.message || "删除失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    handleSubmit(formData) {
      if (this.isEdit) {
        // 编辑
        updateAppVersionConfig(formData)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("更新成功");
              this.dialogVisible = false;
              this.getDataList();
            } else {
              this.$message.error(res.message || "更新失败");
            }
          })
          .catch((error) => {
            this.$message.error(error.message || "更新失败");
          });
      } else {
        // 新增
        addAppVersionConfig(formData)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("新增成功");
              this.dialogVisible = false;
              this.getDataList();
            } else {
              this.$message.error(res.message || "新增失败");
            }
          })
          .catch((error) => {
            this.$message.error(error.message || "新增失败");
          });
      }
    },
  },
};
</script>

<style scoped>
.card_box {
  margin-top: 40px;
}
.other_page_r {
  padding-top: 30px;
}

.search_box {
  margin: 25px;
  display: flex;
  align-items: center;
}

.search_box .el-button {
  padding: 10px 24px;
  font-size: 14px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.search_box .el-button:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.table_box {
  margin-bottom: 20px;
}

.table_footer {
  margin-top: 20px;
}
</style>
